import React from 'react';
import { isEmpty } from 'lodash';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import CustomTooltip from '../../Tooltip/CustomTooltip';
import { shortenStringWithTooltip, toShowArrayToString } from '../../helper';

function ProductCPCard({
  item,
  index,
  selectedIds,
  isArchived,
  isSupplierLoggedIn,
  onCheck,
  handleEdit,
  handlePin,
  deleteCard,
  handleExpand,
  archiveCard,
  handleDuplicate,
  activeInActiveCard,
  productAddEditAccess,
  productDeleteAccess,
  loggedInSupplier,
  subBrandAccess,
}) {
  const { t } = useTranslation('common');

  const dateFormat = 'DD-MMMM-YYYY, h:mm a';
  const showCreatedandModified = () => {
    return (
      <button type="button" className="btn btn-action-icon" style={{ margin: '0' }}>
        <div className="info-container xs-position-bottom iconfirst testing-action-spaceremoval">
          <i className="icon-Information f-24" style={{ position: 'relative', top: '3px' }} />
          <div className="info-content text-nowrap">
            {item?.createdBy?.firstName && (
              <p className="text-left m-0">
                <strong>{t('PRODUCT_CP_LISTING.CREATED')} </strong> : {`${item?.createdBy?.firstName} ${item?.createdBy?.lastName} | `}
                {moment(item?.createdAt).format(dateFormat)}
              </p>
            )}
            {item?.modifiedBy?.firstName && (
              <p className="text-left m-0">
                <strong>{t('PRODUCT_CP_LISTING.MODIFIED')} </strong> : {`${item?.modifiedBy?.firstName} ${item?.modifiedBy?.lastName} | `}
                {moment(item?.updatedAt).format(dateFormat)}
              </p>
            )}
          </div>
        </div>
      </button>
    );
  };

  const showComment = () => {
    return (
      <button type="button" className="btn btn-action-icon " style={{ margin: '0', padding: '0 2px !important' }}>
        <div className="custom-popover-container testing-action-spaceremoval">
          <button type="button">
            <i className="icon-chat-bubble f-24" />
          </button>
          <div className="custom-popover-content">
            <span className="arrow" />
            {item?.archivedBy?.firstName && (
              <p className="text-left m-0">
                {`${item?.archivedBy?.firstName} ${item.archivedBy?.lastName} | `}
                {item?.archivedAt ? moment(item?.archivedAt).format(dateFormat) : null}
              </p>
            )}
            {item?.archiveComment && !isEmpty(item?.archiveComment) && (
              <div className="comment">
                <p className="m-0">{item?.archiveComment}</p>
              </div>
            )}
          </div>
        </div>
      </button>
    );
  };

  return (
    <div className="common-listing-card card mt-5">
      <div className="card-header">
        {!isSupplierLoggedIn && (
          <>
            <ul className="card-header-icon">
              {(productDeleteAccess || productAddEditAccess) && (
                <li>
                  <div className="common-checkbox size-sm">
                    <input
                      onChange={(e) => {
                        onCheck(e, item?._id);
                      }}
                      name={`check_${index}`}
                      id={`check_${index}`}
                      type="checkbox"
                      checked={selectedIds?.includes(item?._id)}
                      disabled={!productAddEditAccess && !productDeleteAccess}
                    />
                    <label htmlFor={`check_${index}`} className="chklabel" />
                  </div>
                </li>
              )}
              {!item?.isArchived && productAddEditAccess && (
                <>
                  <li className="li-padding-remove">
                    <CustomTooltip tooltipText={t('PRODUCT_CP_LISTING.DUPLICATE')}>
                      <button
                        type="button"
                        className="btn btn-action-icon"
                        aria-label={t('PRODUCT_CP_LISTING.DUPLICATE')}
                        onClick={() => handleDuplicate(item)}
                      >
                        <i className="icon-Duplicate-New f-24" />
                      </button>
                    </CustomTooltip>
                  </li>
                  <li className="li-padding-remove">
                    <CustomTooltip tooltipText={t('PRODUCT_CP_LISTING.EDIT')}>
                      <button
                        type="button"
                        onClick={() => handleEdit(item?._id)}
                        className="btn btn-action-icon"
                        aria-label={t('PRODUCT_CP_LISTING.EDIT')}
                        disabled={isArchived}
                      >
                        <i className="icon-Edit-1 f-24" />
                      </button>
                    </CustomTooltip>
                  </li>
                </>
              )}
              {productAddEditAccess && (
                <li className="li-padding-remove">
                  <CustomTooltip tooltipText={item?.isArchived ? t('PRODUCT_CP_LISTING.UNARCHIVE') : t('PRODUCT_CP_LISTING.ARCHIVE')}>
                    <button
                      type="button"
                      onClick={() => archiveCard(item?._id)}
                      aria-label={item?.isArchived ? t('PRODUCT_CP_LISTING.UNARCHIVE') : t('PRODUCT_CP_LISTING.ARCHIVE')}
                      className="btn btn-action-icon"
                    >
                      <i className="icon-Archive f-24" />
                    </button>
                  </CustomTooltip>
                </li>
              )}

              {item?.isArchived && <li>{showComment()}</li>}
              {!item?.isArchived && productAddEditAccess && (
                <li className="li-padding-remove">
                  <CustomTooltip tooltipText={item.isActive ? t('PRODUCT_CP_LISTING.ACTIVE') : t('PRODUCT_CP_LISTING.INACTIVE')}>
                    <button
                      type="button"
                      aria-label={item?.isActive ? t('PRODUCT_CP_LISTING.ACTIVE') : t('PRODUCT_CP_LISTING.INACTIVE')}
                      className={`btn btn-action-icon ${item?.isActive ? 'text-success' : 'text-danger'}`}
                      onClick={() => activeInActiveCard(item, index)}
                    >
                      <i className="icon-active f-24" />
                    </button>
                  </CustomTooltip>
                </li>
              )}
              {productDeleteAccess && isArchived && (
                <li className="li-padding-remove">
                  <CustomTooltip tooltipText={t('PRODUCT_CP_LISTING.DELETE')}>
                    <button type="button" aria-label={t('PRODUCT_CP_LISTING.DELETE')} className="btn btn-action-icon" onClick={() => deleteCard(item?._id)}>
                      <i className="icon-delete f-24" />
                    </button>
                  </CustomTooltip>
                </li>
              )}

              <li className="xs-order-one  p-0">{showCreatedandModified()}</li>
            </ul>
            <div className="ml-auto">
              <ul className="card-header-icon">
                {!item?.isArchived && productAddEditAccess && (
                  <li className="li-padding-remove">
                    <CustomTooltip tooltipText={t('PRODUCT_CP_LISTING.PIN')}>
                      <button
                        type="button"
                        onClick={() => handlePin(item)}
                        className={`btn p-0 d-inline-flex ${item?.pinned && 'text-success'}`}
                        aria-label={t('PRODUCT_CP_LISTING.PIN')}
                        disabled={!productAddEditAccess}
                      >
                        <i className={`icon-marker-pin-save f-22 ${item?.pinned && 'pin-active'}`} />
                      </button>
                    </CustomTooltip>
                  </li>
                )}
              </ul>
            </div>
          </>
        )}
      </div>
      <div className="card-body" onClick={() => handleExpand(item)}>
        <h4 className="title link-title">
          {shortenStringWithTooltip(item?.name, 30)}
          <i className="icon-detail_page pl-1" />
        </h4>
        <ul className="card-ul">
          <li>
            <strong>{t('PRODUCT_CP_LISTING.BRAND')}: </strong>
            {toShowArrayToString(item, 'brand', 30)}
          </li>
          {subBrandAccess && (
            <li>
              <strong>{t('PRODUCT_CP_LISTING.SUBBRAND')}: </strong>
              {toShowArrayToString(item, 'subBrand', 30)}
            </li>
          )}
          <li className="text-truncate">
            <strong>{t('PRODUCT_CP_LISTING.SEASON')}: </strong>
            {toShowArrayToString(item, 'season', 30)}
          </li>
          <li>
            <strong>{t('PRODUCT_CP_LISTING.PRODUCT_TYPE')}: </strong>
            {toShowArrayToString(item, 'productType', 30)}
          </li>
          <li>
            <strong>{t('PRODUCT_CP_LISTING.CATEGORY_ONE')}: </strong>
            {toShowArrayToString(item, 'catOneId', 30)}
          </li>
          <li>
            <strong>{t('PRODUCT_CP_LISTING.CATEGORY_TWO')}: </strong>
            {toShowArrayToString(item, 'catTwoId', 30)}
          </li>
          <li>
            <strong>{t('PRODUCT_CP_LISTING.CATEGORY_THREE')}: </strong>
            {toShowArrayToString(item, 'catThreeId', 30)}
          </li>
          <li>
            <strong>{t('PRODUCT_CP_LISTING.CATEGORY_FOUR')}: </strong>
            {toShowArrayToString(item, 'catFourId', 30)}
          </li>

          <li>
            <strong>{t('PRODUCT_CP_LISTING.SUPPLIER')}: </strong>
            {isSupplierLoggedIn && item?.suppliers?.length > 0
              ? shortenStringWithTooltip(`${item?.suppliers?.find((e) => e?._id === loggedInSupplier?.userId)?.name}`, 30)
              : toShowArrayToString(item, 'suppliers', 30)}
          </li>
        </ul>
      </div>
    </div>
  );
}

export default ProductCPCard;
